<div class="statusbar"  style="position: sticky; padding-bottom: 10px;">
  <div class="statusLabel" #statusLabelLeft></div>
  <div class="statusLabel" class="align-right" #statusLabelRight></div>
</div>
